import { useState, useRef } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import {
    Container,
    Row,
    Col,
    Button,
    Nav,
    Navbar,
    Offcanvas,
    Form,
    Table,
    Stack,
    Badge,
    Alert,
    Card,
} from 'react-bootstrap'

const Home = () => {
    const [copyState, setCopyState] = useState({
        value: '',
        copied: false,
    })
    const [show, setShow] = useState(false)

    const refHome = useRef(null)
    const refHowToPlay = useRef(null)

    const handleClickScrollToHowToPlay = () => refHowToPlay.current?.scrollIntoView({ behavior: 'smooth' })
    const handleClickScrollToHome = () => refHome.current?.scrollIntoView({ behavior: 'smooth' })

    return (
        <div className="bg-light" ref={refHome}>
            <Navbar bg="primary" key="md" expand="md" className="mb-3" data-bs-theme="dark" sticky="top">
                <Container>
                    <Navbar.Brand href="#">
                        <b className="title">Chẵn lẻ Zalo</b>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={() => setShow(true)} aria-controls="offcanvasNavbar-expand-md" />
                    <Navbar.Offcanvas
                        show={show}
                        id="offcanvasNavbar-expand-md"
                        aria-labelledby="offcanvasNavbar-expand-md"
                        placement="end"
                    >
                        <Offcanvas.Header closeButton onClick={() => setShow(false)}>
                            <Offcanvas.Title id="offcanvasNavbar-expand-md">Chẵn lẻ Zalo</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1 pe-3">
                                <Nav.Link
                                    href="#"
                                    onClick={() => {
                                        handleClickScrollToHome()
                                        setShow(false)
                                    }}
                                >
                                    <b>Trang chủ</b>
                                </Nav.Link>
                                <Nav.Link
                                    href="#how-to-play"
                                    onClick={() => {
                                        handleClickScrollToHowToPlay()
                                        setShow(false)
                                    }}
                                >
                                    <b>Cách chơi</b>
                                </Nav.Link>
                            </Nav>
                            <Button variant="light" className="fw-bold">
                                Tải App
                            </Button>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
            <Container>
                <Card className="p-4 mt-3 shadow-sm border-0">
                    <h1 className="bd-title text-center">Chẵn lẻ Zalo - Tự động trả thưởng trong 3s</h1>
                    <p className="bd-lead text-center">Uy tín tạo nên thương hiệu - Cổng game số 1 Việt Nam</p>
                    <hr />
                    <Nav variant="pills" defaultActiveKey="#" className="justify-content-center">
                        <Nav.Item>
                            <Nav.Link href="#">Chẵn lẻ</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="link-1">Tài xỉu</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="link-2">Chẵn lẻ 2</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="link-3">Tài xỉu 2</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Card>
                <Row className="pt-3">
                    <Col lg="4" xl="4" xxl="4">
                        <Card className="p-4 mb-3 shadow-sm border-0">
                            <h3>Cách chơi chẵn lẻ</h3>
                            <Table bordered hover responsive="xxl" className="rounded-3 overflow-hidden mt-1">
                                <thead>
                                    <tr className="bg-primary">
                                        <th className="bg-primary text-white">Số điện thoại</th>
                                        <th className="bg-primary text-white">Trạng thái</th>
                                        <th className="bg-primary text-white">Tối thiểu</th>
                                        <th className="bg-primary text-white">Tối đa</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            0869000955{' '}
                                            <CopyToClipboard
                                                text="0869000955"
                                                onCopy={() =>
                                                    setCopyState({
                                                        value: '0869000955',
                                                        copied: true,
                                                    })
                                                }
                                            >
                                                {copyState.copied && copyState.value === '0869000955' ? (
                                                    <Badge bg="success">Đã sao chép</Badge>
                                                ) : (
                                                    <Badge bg="primary">Sao chép</Badge>
                                                )}
                                            </CopyToClipboard>
                                        </td>
                                        <td>
                                            <Badge bg="success">Hoạt động</Badge>
                                        </td>
                                        <td>10K</td>
                                        <td>2M</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            0974661375{' '}
                                            <CopyToClipboard
                                                text="0974661375"
                                                onCopy={() =>
                                                    setCopyState({
                                                        value: '0974661375',
                                                        copied: true,
                                                    })
                                                }
                                            >
                                                {copyState.copied && copyState.value === '0974661375' ? (
                                                    <Badge bg="success">Đã sao chép</Badge>
                                                ) : (
                                                    <Badge bg="primary">Sao chép</Badge>
                                                )}
                                            </CopyToClipboard>
                                        </td>
                                        <td>
                                            <Badge bg="success">Hoạt động</Badge>
                                        </td>
                                        <td>10K</td>
                                        <td>2M</td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Alert variant="primary">
                                <b>KHÔNG CẦN GHI NỘI DUNG</b>
                                <hr />
                                VD: Bạn đặt <b>Chẵn</b> 50,000. Hãy chuyển số tiền: 500<b>10</b> (<b>10</b> là MÃ)
                                <br />
                                VD: Bạn đặt <b>Lẻ</b> 50,000. Hãy chuyển số tiền: 500<b>11</b> (<b>11</b> là MÃ)
                            </Alert>
                            <Table bordered hover responsive="md" className="rounded-3 overflow-hidden mt-1">
                                <thead className="table-primary">
                                    <tr>
                                        <th className="bg-primary text-white">Đuôi</th>
                                        <th className="bg-primary text-white">Kết quả</th>
                                        <th className="bg-primary text-white">Tỉ lệ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <b>10</b>
                                        </td>
                                        <td>
                                            <Stack direction="horizontal" gap={2}>
                                                <Badge bg="primary">2</Badge>
                                                <Badge bg="primary">4</Badge>
                                                <Badge bg="primary">6</Badge>
                                                <Badge bg="primary">8</Badge>
                                            </Stack>
                                        </td>
                                        <td>
                                            <b>x2.4</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <b>11</b>
                                        </td>
                                        <td>
                                            <Stack direction="horizontal" gap={2}>
                                                <Badge bg="primary">1</Badge>
                                                <Badge bg="primary">3</Badge>
                                                <Badge bg="primary">5</Badge>
                                                <Badge bg="primary">7</Badge>
                                            </Stack>
                                        </td>
                                        <td>
                                            <b>x2.4</b>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                            <Alert variant="primary">
                                Chỉ chuyển vào số điện thoại đang hiển thị trên web và có tình trạng là{' '}
                                <Badge bg="success">Hoạt động</Badge>. Không chuyển và số dùng để trả thưởng.
                            </Alert>
                        </Card>
                        <Card className="p-4 mb-3 shadow-sm border-0">
                            <h3>Kiểm tra mã giao dịch</h3>
                            <p>Nếu quá 3 phút chưa nhận được tiền vui lòng dán mã vào đât để kiểm tra!</p>
                            <Form>
                                <Form.Group className="mb-3" controlId="tradingCode">
                                    <Form.Label>Mã giao dịch</Form.Label>
                                    <Form.Control type="number" placeholder="Nhập mã giao dịch" />
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="phoneNumber">
                                    <Form.Label>Số điện thoại</Form.Label>
                                    <Form.Control type="number" placeholder="Nhập số điện thoại" />
                                </Form.Group>
                                <Button variant="primary" type="submit">
                                    Kiểm tra
                                </Button>
                            </Form>
                        </Card>
                    </Col>
                    <Col lg="8" xl="8" xxl="8">
                        <Card className="p-4 mb-3 shadow-sm border-0">
                            <h3>Lịch sử thắng</h3>
                            <Table bordered hover responsive="xxl" className="rounded-3 overflow-hidden mt-1">
                                <thead>
                                    <tr>
                                        <th className="bg-primary text-white">Thời gian</th>
                                        <th className="bg-primary text-white">Số điện thoại</th>
                                        <th className="bg-primary text-white">Tiền cược</th>
                                        <th className="bg-primary text-white">Tiền thưởng</th>
                                        <th className="bg-primary text-white">Trò chơi</th>
                                        <th className="bg-primary text-white">Đuôi</th>
                                        <th className="bg-primary text-white">Kết quả</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.from({ length: 20 }).map((index) => (
                                        <tr>
                                            <td>01/07 20:22:30</td>
                                            <td>0869000955</td>
                                            <td>100,000đ</td>
                                            <td>195,000đ</td>
                                            <td>Chẵn lẻ 2</td>
                                            <td>
                                                <Badge bg="primary">14</Badge>
                                            </td>
                                            <td>
                                                <Badge bg="success">Thắng</Badge>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                    <Col>
                        <Card className="p-4 mb-3 shadow-sm border-0" ref={refHowToPlay}>
                            <h3>Cách chơi</h3>
                            <Table bordered responsive="md" className="rounded-3 overflow-hidden mt-1">
                                <thead>
                                    <tr>
                                        <th className="bg-primary text-white">Hướng dẫn người mới chơi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <b>BẠN LÀ NGƯỜI MỚI CHƠI, HÃY ĐỌC KỸ CÁCH CHƠI:</b>
                                            <br />
                                            <b>Giới thiệu:</b> Cách chơi Zalo chơi theo số cuối của MÃ GIAO DỊCH của
                                            Zalo, MÃ GIAO DỊCH của Zalo chúng tôi không hề biết được trước kết quả, trò
                                            chơi Xanh Chín không Bê, Tất cả chỉ là đỏ đen.
                                            <br />
                                            <b>Cách chơi:</b>
                                            <br />
                                            1. Bạn hãy tải ví <b>ZaloPay</b> về
                                            <br />
                                            2. Hãy chọn trò chơi mà bạn muốn chơi trên web
                                            <br />
                                            3. Coppy <b>Số Điện Thoại</b> trên web, Vào ví{' '}
                                            <b>ZaloPay -&gt; Chuyển tiền</b> -&gt; Dán SĐT lên ô{' '}
                                            <b>TÌM KIẾM Mục Chuyển Tiền</b>. Nhập số tiền bạn muốn chơi + mã trò chơi
                                            của bạn (2 số cuối của tiền gửi là mã trò chơi, hãy xem VD bên dưới). Chuyển
                                            tiền và Xác nhận
                                            <br />
                                            4. Sau khi chuyển tiền thành công, hãy xem kết quả <b>Mã Giao Dịch</b> trên
                                            Bill của bạn, so sánh với trò chơi bạn chơi trên web thắng hay thua.
                                            <br />
                                            <b>Ví Dụ:</b>
                                            <br />
                                            Bạn chơi 10k Chẵn 1 (Chỉ ăn 2-4-6-8) tỷ lệ 2.4 có mã là 10. Bạn chỉ cần
                                            chuyển tiền là 10010
                                            <br />
                                            Bạn chơi 20k Lẻ 1 (Chỉ ăn 1-3-5-7) tỷ lệ 2.4 có mã là 11. Bạn chỉ cần chuyển
                                            tiền là 20011
                                            <br />
                                            Bạn chơi 50k Chẵn 2 (Chỉ ăn 0-2-4-6-8) tỷ lệ 1.95 có mã là 14. Bạn chỉ cần
                                            chuyển tiền là 50014
                                            <br />
                                            Bạn chơi 45k Lẻ 2 (Chỉ ăn 1-3-5-7-9) tỷ lệ 1.95 có mã là 15. Bạn chỉ cần
                                            chuyển tiền là 45015
                                            <br />
                                            ....
                                            <br />
                                            Các trò chơi khác đều có cách chơi tương tự
                                            <br />
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                </Row>

                <Card className="pt-3 pb-2 mb-3 shadow-sm border-0">
                    <h5 className="text-center text-primary">Chẵn lẻ Zalo</h5>
                </Card>
            </Container>
        </div>
    )
}

export default Home
